<template>
  <div>
    <v-data-table :items="organisations" :headers="headers">
      <template v-slot:items="props">
        <td class="text-xs-center">
          {{ props.item.name }}
        </td>
        <td class="text-xs-center">
          {{ props.item.networkAPI }}
        </td>
        <td class="text-xs-center">
          <v-icon v-if="props.item.sockets.syncSocket" color="light-green"
            >fiber_manual_record</v-icon
          >
          <v-icon v-else color="red">fiber_manual_record</v-icon>
        </td>
        <td class="text-xs-center">
          <v-icon
            v-if="props.item.sockets.provisioningSocket"
            color="light-green"
            >fiber_manual_record</v-icon
          >
          <v-icon v-else color="red">fiber_manual_record</v-icon>
        </td>
        <td class="text-xs-center">
          <v-icon v-if="props.item.sockets.statusSocket" color="light-green"
            >fiber_manual_record</v-icon
          >
          <v-icon v-else color="red">fiber_manual_record</v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Api from "../services/Api";
export default {
  data() {
    return {
      organisations: [],
      headers: [
        {
          text: "Organisation",
          align: "name",
        },
        {
          text: "API Endpoint",
          align: "center",
          value: "networkAPI",
        },
        {
          text: "Sync WS",
          align: "center",
          value: "sockets.syncSocket",
        },
        {
          text: "Provisioning WS",
          align: "center",
          value: "sockets.provisioningSocket",
        },
        {
          text: "Status WS",
          align: "center",
          value: "sockets.statusSocket",
        },
      ],
    };
  },
  created() {
    this.fetchOrgs();
  },
  methods: {
    async fetchStatus(org) {
      let syncSocket = false;
      let provisioningSocket = false;
      let statusSocket = false;
      await Api()
        .get("/zhone/syncSocketStatus/" + org.id)
        .then((response, err) => {
          if (err) syncSocket = false;
          else syncSocket = response.data;
        });
      await Api()
        .get("/zhone/provisioningSocketStatus/" + org.id)
        .then((response, err) => {
          if (err) provisioningSocket = false;
          else provisioningSocket = response.data;
        });
      await Api()
        .get("/zhone/onuStatusSocket/" + org.id)
        .then((response, err) => {
          if (err) statusSocket = false;
          else statusSocket = response.data;
        });
      return {
        syncSocket: syncSocket,
        provisioningSocket: provisioningSocket,
        statusSocket: statusSocket,
      };
    },
    async fetchOrgs() {
      await Api()
        .get("/organisation/networkSync")
        .then(async (response) => {
          let organisations = response.data;
          for (let i = 0; i < organisations.length; i++) {
            organisations[i].sockets = await this.fetchStatus(organisations[i]);
          }
          this.organisations = organisations;
          console.log(organisations);
        });
    },
  },
};
</script>